import React, { useEffect, useState } from "react";
import Select from "react-dropdown-select";
import { AppSettings } from "../../constant";
import { toast } from "react-toastify";
import axiosInstance from "../../axios-interceptor";

function AllcoateAsset(data) {
  const [isAllocateformOpen, setIsAllocateFormOpen] = useState(false);
  const customId = "custom-id-yes";
  const dateToFormat = new Date();
  const [inputValues, setInputValues] = useState({});
  const [userId, setUserId] = useState("");
  const [dropdownOptions, setDropdownOptions] = useState([]);
  const [sidebarAction, setSidebarAction] = useState("add");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [allocateSelectedValue, setAllocateSelectedValue] = useState({
    assetid: { value: data.data?.id, label: data.data?.id },
    userid: { value: data.data.assignedToUserId, label: data.data.assignedToUserId },
    username: {
      value: data.data.assignedToUserId,
      label: data.data.assignedTo ? data.data.assignedTo : " ",
    },
    assetType: { value: data.asset, label: data.asset },
    assetName: { value: data.data?.systemId, label: data.data?.systemId },
    newUsername: { value: null, label: "Select User to Reassign" },
  });
  const [dataError, setDataError] = useState({
    username: false,
    assignedOn: false,
    assignedTill: false,
    remarks: false,
  });

  const fetchAllUsers = async () => {
    try {
      const res = await axiosInstance.get(AppSettings.URLs.getAllUsers);
      const newDropdown = res.data.response.users;
      newDropdown.unshift({ id: 0, username: " " });
      setDropdownOptions(newDropdown);
    } catch (error) {
      console.log("Error fetching dropdown options:", error);
    }
  };

  useEffect(() => { }, []);

  const handleAssignUser = async (action, item) => {
    fetchAllUsers();
    setSidebarAction(action);
    setIsSubmitting(false);

    if (action === "edit") {
      try {
        const userData = await axiosInstance.get(
          AppSettings.URLs.getUserById + item.assignedToUserId
        );
        // setUserId(userData?.data?.response?.user[0]?.empid);
      } catch (error) {
        console.log(error);
      } setUserId("");

      setInputValues({
        assetid: data.data.id,
        assetType: data.asset,
        assetName: data.data.systemId,
        userId: "",
        username: item?.assignedTo,
        newUsername: null,
        newUserId: null,
        assignedOn: "",

        assignedTill: data.data?.assignedTill
          ? data.data?.assignedTill?.substring(0, 10)
          : "",
        remarks: data.data?.remarks || "",
      });

      setAllocateSelectedValue({
        assetid: { value: data.data?.id, label: data.data?.id },
        userid: { value: data.data.assignedToUserId, label: data.data.assignedToUserId },
        username: {
          value: data.data.assignedToUserId,
          label: data.data.assignedTo ? data.data.assignedTo : " ",
        },
        newUsername: { value: null, label: "Select User" },
        assetType: { value: data.asset, label: data.asset },
        assetName: { value: data.data?.systemId, label: data.data?.systemId },
      });

    } else {
      // ADD mode — simple flow
      setUserId("");
      setInputValues({
        assetid: data.data.id,
        assetType: data.asset,
        assetName: data.data.systemId,
        userId: null,
        username: null,
        assignedOn: new Date().toISOString().split("T")[0],
      });

      setAllocateSelectedValue({
        assetid: { value: data.data?.id, label: data.data?.id },
        userid: { value: null, label: "" },
        username: { value: null, label: " " },
        newUsername: { value: null, label: "Select User to Reassign" },
        assetType: { value: data.asset, label: data.asset },
        assetName: { value: data.data?.systemId, label: data.data?.systemId },
      });
    }

    setIsAllocateFormOpen(true);
  };

  const handleAssignUserformClose = () => {
    setInputValues({});
    setIsAllocateFormOpen(false);
    setUserId("");
    setSidebarAction("add");
    setIsSubmitting(false);
    setDataError({
      username: false,
      assignedOn: false,
      assignedTill: false,
      remarks: false,
    });
  };

  const handleFormSubmit = () => {
    if (isSubmitting) return;
    let isFormFilled = false;

    if (sidebarAction === "add") {

      setDataError({
        username:
          inputValues?.username === undefined || inputValues?.username === null
            ? true
            : false,
        assignedOn: false,
        assignedTill: false,
        remarks: false,
      });

      if (
        inputValues?.username !== undefined &&
        inputValues?.username !== null
      ) {
        if (
          inputValues.assignedOn >
          dateToFormat.toISOString().split("T")[0]
        ) {
          setDataError((prev) => ({ ...prev, assignedOn: true }));
          toast.error("Assigned On can't be greater than today's date!", {
            toastId: customId,
          });
        } else {
          isFormFilled = true;
        }
      }

    } else {

      const tillMissing =
        !inputValues?.assignedTill || inputValues?.assignedTill === "";
      const remarksMissing =
        !inputValues?.remarks || inputValues?.remarks.trim() === "";

      setDataError({
        username: false,
        assignedOn: false,
        assignedTill: tillMissing,
        remarks: remarksMissing,
      });

      if (tillMissing || remarksMissing) {
        toast.error("Please fill all required fields", { toastId: customId });
        return;
      }

      // if (
      //   inputValues.assignedTill &&
      //   inputValues.assignedTill < inputValues.assignedOn
      // ) {
      //  // setDataError((prev) => ({ ...prev, assignedTill: true }));
      //  // toast.error("Assigned Till can't be before Assigned On!", {
      //  //   toastId: customId,
      //   });
      //return;
      //}

      isFormFilled = true;
    }

    if (isFormFilled) {
      let payload;

      if (sidebarAction === "add") {
        payload = {
          assetId: data.data.id,
          userId: inputValues?.userId,
          userName: inputValues?.username,
          assetType: data.asset,
          assetName: data.data.systemId,
          assignedOn: inputValues?.assignedOn,
        };
      } else {

        const finalUserId =
          inputValues?.newUserId != null
            ? inputValues?.newUserId
            : inputValues?.userId;

        const finalUserName =
          inputValues?.newUsername != null
            ? inputValues?.newUsername
            : inputValues?.username;

        payload = {
          assetId: data.data.id,
          assetType: data.asset,
          assetName: data.data.systemId,
          assignedTill: inputValues?.assignedTill,
          remarks: inputValues?.remarks,
          ...(inputValues?.assignedOn ? { assignedOn: inputValues.assignedOn } : {}),
          ...(inputValues?.newUserId != null
            ? { userId: inputValues.newUserId, userName: inputValues.newUsername }
            : {}),
        };
      }

      const apiCall =
        data.data.assignedTo === null || data.data.assignedTo === ""
          ? axiosInstance.post(AppSettings.URLs.assetAllocate, payload)
          : axiosInstance.post(AppSettings.URLs.updateAssetAllocate, payload);

      setIsSubmitting(true);

      apiCall
        .then((res) => {
          const statusCode = res?.data?.statuscode;
          const message = res?.data?.message;

          if (statusCode === undefined || statusCode === 200) {
            data.getAsset(data.asset);
            toast.success(message || "Updated Successfully", { toastId: customId });
            handleAssignUserformClose();
            setInputValues({});
          } else {
            toast.error(message || "Something went wrong", { toastId: customId });
            setIsSubmitting(false);
          }
        })
        .catch((error) => {
          console.log(error);
          toast.error(error?.response?.data?.message || "Something went wrong", {
            toastId: customId,
          });
          setIsSubmitting(false);
        });
    } else {
      if (sidebarAction === "add") {
        toast.error("Please fill all required fields", { toastId: customId });
      }
    }
  };

  return (
    <>

      <button
        className={`btn btn-sm border-radius-4 d-flex align-items-center justify-content-center btn-secondary whitespace-nowrap ${data.data.assignedTo === null || data.data.assignedTo === ""
          ? ""
          : "!hidden"
          } ${data.data.isActive
            ? "cursor-pointer"
            : "!cursor-not-allowed opacity-60"
          }`}
        onClick={() => data.data.isActive && handleAssignUser("add", null)}
      >
        Assign User
      </button>

      <button
        className={`btn btn-sm border-radius-4 d-flex align-items-center justify-content-center btn-primary whitespace-nowrap ${data.data.assignedTo === null || data.data.assignedTo === ""
          ? "!hidden"
          : ""
          }`}
        onClick={() => handleAssignUser("edit", data.data)}
      >
        Update User
      </button>

      {/* Overlay */}
      <div
        className={`kr-popup-overlay ${isAllocateformOpen ? "kr-side-popup-overlay" : ""
          }`}
      ></div>

      {/* Sidebar */}
      <div
        className={`kr-side-popup ${isAllocateformOpen ? "kr-side-popup-on" : ""
          }`}
      >
        <div className="kr-block w-100">
          <div className="flex items-center py-[16px] px-6 bg-gray-50">
            <div className="pl-2">
              <h2 className="font-bold color-dark text-[14px] mb-0">
                {sidebarAction === "edit"
                  ? "Update Asset Allocation"
                  : "Allocate Asset"}
              </h2>
              <span className="text-gray-400 text-[12px]">
                {sidebarAction === "edit"
                  ? "Update or reassign the allocated asset"
                  : "Allocate asset to user"}
              </span>
            </div>
          </div>

          <div className="kr-block p-4">
            <div id="form">
              <div className="grid gap-x-4 !grid-cols-1">


                <div className="col-span-2">
                  <div className="kr-selectform required">
                    <label className="kr-form-label">Asset Type</label>
                    <input
                      type="text"
                      value={allocateSelectedValue?.assetType?.label || ""}
                      className="form-control kr-form-textbox bg-gray-100 text-gray-500 cursor-not-allowed"
                      disabled
                    />
                  </div>
                </div>
                <div className="col-span-2">
                  <div className="kr-selectform required">
                    <label className="kr-form-label">Asset Name</label>
                    <input
                      type="text"
                      value={allocateSelectedValue?.assetName?.label || ""}
                      className="form-control kr-form-textbox bg-gray-100 text-gray-500 cursor-not-allowed"
                      disabled
                    />
                  </div>
                </div>

                {sidebarAction === "add" ? (
                  <>
                    <div className="col-span-2">
                      <div className="kr-selectform required">
                        <label className="kr-form-label">Assign User</label>
                        <Select
                          backspaceDelete={false}
                          placeholder="Select User"
                          name="username"
                          values={
                            allocateSelectedValue?.username?.value
                              ? [allocateSelectedValue.username]
                              : []
                          }
                          className={`form-control kr-form-textbox placeholder-[#212529] ${dataError.username ? "dataError" : ""
                            }`}
                          options={dropdownOptions?.map((option) => ({
                            value: option?.id,
                            label: option?.username,
                          }))}
                          onChange={(selectedOption) => {
                            const newLabel = selectedOption[0]?.label;
                            const newValue = selectedOption[0]?.value;

                            setAllocateSelectedValue((prev) => ({
                              ...prev,
                              username: { value: newValue, label: newLabel },
                            }));
                            setInputValues((prev) => ({
                              ...prev,
                              username: newLabel,
                              userId: newValue,
                            }));

                            if (newValue && newLabel !== "") {
                              axiosInstance
                                .get(AppSettings.URLs.getUserById + newValue)
                                .then((res) =>
                                  setUserId(res?.data?.response?.user[0]?.empid || "")
                                )
                                .catch(console.log);
                            } else {
                              setUserId("");
                            }
                          }}
                        />
                      </div>
                    </div>

                    <div className="col-span-2">
                      <div className="kr-selectform">
                        <label className="kr-form-label">User ID</label>
                        <input
                          type="text"
                          placeholder="User ID"
                          value={userId}
                          className="form-control kr-form-textbox placeholder-[#212529] bg-gray-100 text-gray-500 cursor-not-allowed"
                          disabled
                        />
                      </div>
                    </div>

                    <div className="col-span-2">
                      <div className="kr-selectform">
                        <label className="kr-form-label">Assigned Date</label>
                        <input
                          type="date"
                          value={inputValues?.assignedOn || ""}
                          onChange={(e) =>
                            setInputValues((prev) => ({
                              ...prev,
                              assignedOn: e.target.value,
                            }))
                          }
                          onKeyDown={(e) => e.preventDefault()}
                          onPaste={(e) => e.preventDefault()}
                          className={`form-control kr-form-textbox placeholder-[#212529] ${dataError.assignedOn ? "dataError" : ""
                            }`}
                        />
                      </div>
                    </div>

                  </>
                ) : (
                  <>

                    <div className="col-span-2">
                      <div className="kr-selectform">
                        <label className="kr-form-label">Assigned User</label>
                        <input
                          type="text"
                          value={allocateSelectedValue?.username?.label || ""}
                          className="form-control kr-form-textbox bg-gray-100 text-gray-500 cursor-not-allowed"
                          disabled
                        />
                      </div>
                    </div>
                    <div className="col-span-2">
                      <div className="kr-selectform required">
                        <label className="kr-form-label">Assigned Till</label>
                        <input
                          type="date"
                          value={inputValues?.assignedTill || ""}
                          onChange={(e) =>
                            setInputValues((prev) => ({
                              ...prev,
                              assignedTill: e.target.value,
                            }))
                          }
                          onKeyDown={(e) => e.preventDefault()}
                          onPaste={(e) => e.preventDefault()}
                          className={`form-control kr-form-textbox placeholder-[#212529] ${dataError.assignedTill ? "dataError" : ""
                            }`}
                        />
                      </div>
                    </div>

                    <div className="col-span-2">
                      <div className="kr-selectform required">
                        <label className="kr-form-label">Remarks</label>
                        <input
                          type="text"
                          placeholder="Enter remarks"
                          value={inputValues?.remarks || ""}
                          onChange={(e) =>
                            setInputValues((prev) => ({
                              ...prev,
                              remarks: e.target.value,
                            }))
                          }
                          className={`form-control kr-form-textbox placeholder-[#212529] ${dataError.remarks ? "dataError" : ""
                            }`}
                        />
                      </div>
                    </div>

                    <div className="col-span-2">
                      <div className="kr-selectform">
                        <label className="kr-form-label">Reassign User</label>
                        <Select
                          backspaceDelete={false}
                          placeholder="Select User"
                          name="newUsername"
                          values={[
                            allocateSelectedValue?.newUsername ?? {
                              value: null,
                              label: "Select user to reassign",
                            },
                          ]}
                          className="form-control kr-form-textbox placeholder-[#212529]"
                          options={dropdownOptions?.map((option) => ({
                            value: option?.id,
                            label: option?.username,
                          }))}
                          onChange={(selectedOption) => {
                            const newLabel = selectedOption[0]?.label;
                            const newValue = selectedOption[0]?.value;

                            setAllocateSelectedValue((prev) => ({
                              ...prev,
                              newUsername: { value: newValue, label: newLabel },
                            }));
                            setInputValues((prev) => ({
                              ...prev,
                              newUserId: newValue,
                              newUsername: newLabel,
                              assignedOn: new Date().toISOString().split("T")[0], // add this
                            }));

                            if (newValue && newLabel !== 0) {
                              axiosInstance
                                .get(AppSettings.URLs.getUserById + newValue)
                                .then((res) => setUserId(res?.data?.response?.user[0]?.empid || ""))
                                .catch(console.log);
                            } else {
                              setUserId("");
                            }
                          }}
                        />
                      </div>
                    </div>

                    <div className="col-span-2">
                      <div className="kr-selectform">
                        <label className="kr-form-label">User ID</label>
                        <input
                          type="text"
                          placeholder="User ID"
                          value={userId}
                          className="form-control kr-form-textbox placeholder-[#212529] bg-gray-100 text-gray-500 cursor-not-allowed"
                          disabled
                        />
                      </div>
                    </div>

                    <div className="col-span-2">
                      <div className="kr-selectform">
                        <label className="kr-form-label">Assigned On</label>
                        <input
                          type="date"
                          value={inputValues?.assignedOn || ""}
                          onChange={(e) =>
                            setInputValues((prev) => ({
                              ...prev,
                              assignedOn: e.target.value,
                            }))
                          }
                          onKeyDown={(e) => e.preventDefault()}
                          onPaste={(e) => e.preventDefault()}
                          className={`form-control kr-form-textbox placeholder-[#212529] ${dataError.assignedOn ? "dataError" : ""
                            }`}
                        />
                      </div>
                    </div>

                  </>
                )}

                <div className="col-span-2">
                  <div className="kr-selectform flex justify-end">
                    <button
                      type="button"
                      className="flex items-center justify-center py-[6px] px-[12px] btn-light border border-solid border-gray-200 rounded min-w-80"
                      onClick={handleAssignUserformClose}
                    >
                      Cancel
                    </button>
                    <button
                      type="button"
                      className="btn btn-primary flex items-center justify-center ml-2 min-w-80 disabled:!bg-[#fc5b0b] disabled:!border-[#fc5b0b] disabled:!text-white disabled:!opacity-100 disabled:cursor-not-allowed"
                      onClick={handleFormSubmit}
                      disabled={isSubmitting}
                    >
                      {isSubmitting ? "Save" : "Save"}
                    </button>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default AllcoateAsset;